import { FilmIcon } from "@heroicons/react/24/outline";
import { useEffect,useState } from "react";

import { useVideoGenerationStore } from "@/stores/videoGeneration.store";

function formatElapsedTime(startTime: string): string {
  const elapsed = Math.floor(
    (Date.now() - new Date(startTime).getTime()) / 1000,
  );

  if (elapsed < 1) {
    return "0s";
  }

  // Poniżej minuty - pokazuj sekundy
  if (elapsed < 60) {
    return `${elapsed}s`;
  }

  // Poniżej godziny - pokazuj minuty
  if (elapsed < 3600) {
    const minutes = Math.floor(elapsed / 60);
    return `${minutes} min`;
  }

  // Powyżej godziny
  const hours = Math.floor(elapsed / 3600);
  return `${hours} godz`;
}

export function VideoGenerationBar() {
  const { pending, isPolling, completedVideoId } = useVideoGenerationStore();
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!pending || !isPolling) return;

    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);

    return () => { clearInterval(interval); };
  }, [pending, isPolling]);

  if (!pending || !isPolling || completedVideoId) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-accent text-white px-4 py-4">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative">
            <FilmIcon className="size-5" />
            <span className="absolute -top-1 -right-1 flex size-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
              <span className="relative inline-flex rounded-full size-2 bg-white"></span>
            </span>
          </div>
          <div>
            <p className="font-medium">Trwa generowanie filmu...</p>
            <p className="text-sm text-white/70">
              {pending.videoName} &middot;{" "}
              {formatElapsedTime(pending.createdAt)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
